import { useFormikContext } from "formik";
import React, { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

import { RegimeTypeOptions } from "../../../config/filingConstants";
import { IFormITR1 } from "../../../config/interfaces";
import PriceDisplay from "../../PriceDisplay";
import CompareRegimesModal from "../../modals/CompareRegimesModal";

type Props = {
  handleFileNowSubmit: () => void;
};

const ReviewSummaryCard: React.FC<Props> = (props: Props) => {
  const {} = props;

  const { values } = useFormikContext<IFormITR1>();

  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  return (
    <>
      <section className="efiling-summary-section">
        <div className="section-title-wrap">
          <h4 className="text-primary fw-bold">Summary</h4>
          <span className="helper-text text-greyDark">
            Tax will be filed under&nbsp;
            <span role="button" className="fw-bold text-secondary">
              {values.FilingReturnInfo.FormName}
            </span>
            &nbsp;using&nbsp;
            <span role="button" className="fw-bold text-secondary">
              {RegimeTypeOptions[values.FilingReturnInfo.RegimeType]}
            </span>
            &nbsp;&nbsp;
            <span
              role="button"
              className="text-decoration-underline fw-bold text-primary"
              onClick={() => setShowConfirmation(true)}
            >
              Compare Regimes
            </span>
          </span>
        </div>
        <Card className="summary-card shadow-none">
          <Card.Header>
            <Row>
              <Col sm={6} md>
                <h2 className="fw-bold text-primary">
                  <PriceDisplay price={values.GrossTotIncome} />
                </h2>
                <span className="leading-para text-greyDark">Gross Income</span>
              </Col>
              <Col sm={6} md>
                <h2 className="fw-bold text-primary">
                  <PriceDisplay price={values.TotalTaxableIncome} />
                </h2>
                <span className="leading-para text-greyDark">Taxable Income</span>
              </Col>
              <Col sm={6} md>
                <h2 className="fw-bold text-primary">
                  <PriceDisplay price={values.ITR1_TaxComputation.TotTaxPlusIntrstPay} />
                </h2>
                <span className="leading-para text-greyDark">Tax Liability</span>
              </Col>
              <Col sm={6} md>
                <h2 className="fw-bold text-primary">
                  <PriceDisplay price={values.TaxPaid.TaxesPaid.TotalTaxesPaid} />
                </h2>
                <span className="leading-para text-greyDark">Taxes Paid</span>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Row className="align-items-center">
              <Col md>
                <h5>Tax Due or Refund</h5>
                <h2 className="fw-bold">
                  {values.TaxPaid.BalTaxPayable < 0 ? (
                    <>
                      None (
                      <PriceDisplay price={values.TaxPaid.BalTaxPayable} /> Refund)
                    </>
                  ) : (
                    <>
                      {values.TaxPaid.BalTaxPayable > 0 ? (
                        <PriceDisplay price={values.TaxPaid.BalTaxPayable} />
                      ) : (
                        <PriceDisplay price={0} />
                      )}
                    </>
                  )}
                </h2>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </section>

      <CompareRegimesModal
        showModal={showConfirmation}
        title="Regime Comparison"
        handleModalClose={() => setShowConfirmation(false)}
        values={values}
      />
    </>
  );
};

export default ReviewSummaryCard;
